import { useContext } from "react";
import useUrlQueryFilters from "components/common/EntityFilters/hooks/useUrlQueryFilters";
import TableFilterContext from "components/common/PaginatedEntityTable/TableFilterContext";
const useAppendFilter = (attributeId) => {
  const tableFilterContext = useContext(TableFilterContext);
  const [urlFilters, setUrlFilters] = useUrlQueryFilters();
  return (value) => {
    var _a;
    const currentFilters = (_a = tableFilterContext == null ? void 0 : tableFilterContext.searchParams.filters) != null ? _a : urlFilters;
    const existing = currentFilters.get(attributeId, []);
    if (existing.includes(value)) return;
    setUrlFilters(currentFilters.set(attributeId, [...existing, value]));
  };
};
export default useAppendFilter;
